<template>
  <div>
    <p class="cm-mg-p-wzd">{{ $t('boxinspection.firstStepInfo') }}</p>
    <hr />
    <div class="row">
      <select-component
        :rowClass="`col-12 col-md-6 col-xl-4`"
        :isMultiple="false"
        :dataOptions="locations"
        :requireClass="`required-location-id`"
        @onChange="handleChangeSelected"
        :labelSelect="`${$t('boxinspection.inspection_location')}: *`"
        modelName="location_id"
        :initialSelection="model.location_id"
      />
      <select-component
        :rowClass="`col-12 col-md-6 col-xl-4`"
        :isMultiple="false"
        :dataOptions="farms"
        :requireClass="`required-farm-id`"
        @onChange="handleChangeSelected"
        :labelSelect="`${$t('common_words.farm')}: *`"
        modelName="farm_id"
        :initialSelection="model.farm_id"
      />
      <select-component
        :rowClass="`col-12 col-md-4`"
        :isMultiple="false"
        :dataOptions="boxesByFarm"
        :requireClass="`required-box-id`"
        @onChange="handleChangeSelected"
        :labelSelect="`${$t('production.box')}: *`"
        modelName="box_id"
        :initialSelection="model.box_id"
      />
      <select-component
        :rowClass="`col-12 col-md-4 col-lg-2`"
        :isMultiple="false"
        :dataOptions="boxesQuantity"
        :requireClass="`required-box-quantity`"
        @onChange="handleChangeSelected"
        :labelSelect="`${$t('production.boxes_quantity')}: *`"
        modelName="box_quantity"
        :initialSelection="model.box_quantity"
      />
      <select-component
        :rowClass="`col-12 col-md-4 col-lg-2`"
        :isMultiple="false"
        :dataOptions="palletQuantity"
        :requireClass="`required-pallet-quantity`"
        @onChange="handleChangeSelected"
        :labelSelect="`# Pallet: *`"
        modelName="pallet_quantity"
        :initialSelection="model.pallet_quantity"
      />
      <div class="col-12 col-lg-4 col-xl-4">
        <div class="form-group has-label shadow-sm">
          <label>{{ $t('common_words.date') }}: *</label>
          <el-date-picker
            class="required-date"
            :picker-options="pickerOptions"
            v-model="model.date"
            type="date"
            :placeholder="$t('common_words.date_pick')"
          >
          </el-date-picker>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import mixinLocation from 'src/util/mixinLocation';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import moment from 'moment';

export default {
  data() {
    return {
      model: {
        isEdit: false,
        id: null,
        farm_id: null,
        box_id: null,
        box_quantity: null,
        pallet_quantity: null,
        location_id: null,
        date: null,
        user_id: this.$store.state.auth.user.id,
        box_3lb: false,
        latitude: null,
        longitude: null,
        altitude: null,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      compliancePercentage: 0,
      farms: [],
      boxes: [],
      boxesByFarm: [],
      locations: [],
      boxesQuantity: [
        { id: 1, name: '1' },
        { id: 2, name: '2' },
        { id: 3, name: '3' },
        { id: 4, name: '4' },
        { id: 5, name: '5' },
        { id: 6, name: '6' },
        { id: 7, name: '7' },
        { id: 8, name: '8' },
        { id: 9, name: '9' },
        { id: 10, name: '10' },
      ],
      palletQuantity: [
        { id: 1, name: '1' },
        { id: 2, name: '2' },
        { id: 3, name: '3' },
        { id: 4, name: '4' },
        { id: 5, name: '5' },
        { id: 6, name: '6' },
        { id: 7, name: '7' },
        { id: 8, name: '8' },
        { id: 9, name: '9' },
        { id: 10, name: '10' },
        { id: 11, name: '11' },
        { id: 12, name: '12' },
        { id: 13, name: '13' },
        { id: 14, name: '14' },
        { id: 15, name: '15' },
        { id: 16, name: '16' },
        { id: 17, name: '17' },
        { id: 18, name: '18' },
        { id: 19, name: '19' },
        { id: 20, name: '20' },
        { id: 21, name: '21' },
      ],
    };
  },
  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinForm,
    MixinLoading,
    MixinValidations,
    mixinLocation,
  ],
  watch: {
    'model.date': {
      handler(newDate) {
        if (newDate && this.model.farm_id) {
          this.loadQualityPercentages(this.model.farm_id);
        }
      },
    },
  },
  methods: {
    filterBoxesByFarm(farmId) {
      if (farmId && this.boxes.length > 0) {
        this.boxesByFarm = this.boxes.filter(
          (box) => box.farms_id && box.farms_id.includes(farmId)
        );
      } else {
        this.boxesByFarm = [];
      }
    },
    validate() {
      return this.$validator
        .validateAll()
        .then((responseInputs) => {
          this.$emit('on-validated', {
            ...this.model,
            compliancePercentage: this.compliancePercentage,
            farmSelected: this.model.farm_id
              ? this.getNameSelected(this.model.farm_id, this.farms)
              : null,
            boxSelected: this.model.box_id
              ? this.boxes.find((box) => box.id === this.model.box_id)
              : null,
            locationSelected: this.model.location_id
              ? this.getNameSelected(this.model.location_id, this.locations)
              : null,
          });

          return responseInputs;
        })
        .then((responseSelects) => {
          if (!responseSelects) return responseSelects;
          if (!isset(this.model.farm_id)) {
            return this.validationInputsRequired('farm-id');
          } else if (!isset(this.model.box_id)) {
            return this.validationInputsRequired('box-id');
          } else if (!isset(this.model.box_quantity)) {
            return this.validationInputsRequired('box-quantity');
          } else if (!isset(this.model.pallet_quantity)) {
            return this.validationInputsRequired('pallet-quantity');
          } else if (!isset(this.model.location_id)) {
            return this.validationInputsRequired('location-id');
          } else if (!isset(this.model.date)) {
            return this.validationInputsRequired('date');
          } else return true;
        });
    },
    handleChangeSelected(data) {
      switch (data.name) {
        case 'farm_id':
          this.filterBoxesByFarm(data.selects);
          this.loadQualityPercentages(data.selects);
          this.model.box_id = null;

          break;
        case 'box_id':
          const selectedBox = this.boxes.find((box) => box.id === data.selects);
          this.model.box_3lb = selectedBox.box_3lb == 1 ? true : false;

          break;
      }

      this.$set(this.model, data.name, data.selects);
    },

    loadQualityPercentages(farmId) {
      if (!farmId || !this.model.date) {
        this.compliancePercentage = 0;
        this.notifyParentCompliancePercentage();
        return;
      }

      this.showHideLoading(true);
      const dateString = moment(this.model.date).format('YYYY-MM-DD');

      Axios.getMasters(`quality/qualitypercentages/${farmId}/${dateString}`)
        .then((response) => {
          this.compliancePercentage = response.data.data;

          // Emitimos al padre
          this.notifyParentCompliancePercentage();

          this.showHideLoading();
        })
        .catch((error) => {
          console.error('Error loading quality percentages:', error);
          this.compliancePercentage = 0;
          this.notifyParentCompliancePercentage();
          this.showHideLoading();
        });
    },

    notifyParentCompliancePercentage() {
      this.$emit('update-compliance', this.compliancePercentage);
    },
  },
  created() {
    this.showHideLoading(true);

    this.getPosition()
      .then((locationData) => {
        if (locationData) {
          this.model.latitude = locationData.lat;
          this.model.longitude = locationData.lng;
          this.model.altitude = locationData.alt;
        }
      })
      .catch((error) => {
        console.error('Error obteniendo geolocalización:', error);
      });

    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('farms/farms/onlyfruit'),
        Axios.getMasters('boxes/boxes'),
        Axios.getMasters('quality/locationinspections'),
      ])
        .then(([farmsResponse, boxesResponse, locationsResponse]) => {
          this.farms = farmsResponse.data.data.map((farm) => ({
            ...farm,
            name: `${farm.code} - ${farm.name}`,
          }));
          this.boxes = boxesResponse.data.data.map((box) => ({
            ...box,
            name: `${box.code} - ${box.name}`,
          }));
          this.locations = locationsResponse.data.data;

          // Si estamos en modo edición y ya tenemos un farm_id, filtrar las cajas
          // y consultar el porcentaje de calidad
          if (this.model.farm_id) {
            this.filterBoxesByFarm(this.model.farm_id);
            this.loadQualityPercentages(this.model.farm_id);
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else this.showHideLoading();
  },
  mounted() {
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const {
        id,
        farm_id,
        box_id,
        boxes_quantity,
        number_pallet,
        location_inspection_id,
        date_save,
        box,
      } = editForm;

      this.model = {
        ...this.model,
        isEdit: true,
        id: id,
        farm_id,
        box_id,
        box_quantity: boxes_quantity,
        pallet_quantity: number_pallet,
        location_id: location_inspection_id,
        date: date_save ? new Date(date_save) : null,
        box_3lb: box && box.box_3lb == 1 ? true : false,
      };
    }
  },
};
</script>
